import InfoIcon from "@/app/shared-components/icons/InfoIcon";

const Info = ({ content, classes }: { content?: any; classes?: string }) => {
  return (
    <div className={`flex justify-center items-center gap-2 ${classes ? classes : ""}`}>
      <InfoIcon variant={3} className={"size-3.5 lg:size-6 text-[#898994] shrink-0"} />
      <span className={"text-[#4C4C52] font-jost text-xs leading-4 lg:text-base lg:leading-[22px]"}>{content}</span>
    </div>
  );
};
export default Info;
